
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M10 31.6V18.4h9V21h-6.1v2.7h5.3v2.6h-5.3v2.9H19v2.6h-9v-.2zM25.5 25.4l-1.3-2.7h-.1v8.9h-2.7V18.4h3.2l3.6 6.3 1.3 2.7h.1v-8.9h2.7v13.3h-3.2l-3.6-6.4z"}})]),_c('path',{attrs:{"d":"M42.8 25l7-14.8c.3-.6.2-1.3-.1-1.9-.4-.6-1-.9-1.7-.9H2c-1.1 0-2 .9-2 2v31.2c0 1.1.9 2 2 2h46c.7 0 1.3-.3 1.7-.9.4-.6.4-1.3.1-1.9l-7-14.8zM3.9 38.7V11.3H45l-6.1 12.8c-.3.5-.3 1.1 0 1.7L45 38.7H3.9z","fill":"#fff"}})])
          )
        }
      }
    